import React from 'react';

interface ErrorDisplayProps {
  error: string | null | undefined;
  className?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, className = '' }) => {
  if (!error) return null;

  return (
    <div className={`flex items-center gap-2 px-3 py-2 rounded-xl bg-red-50 border border-red-200 ${className}`}>
      <svg className="w-4 h-4 text-red-500 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
      </svg>
      <p className="text-sm text-red-600">{error}</p>
    </div>
  );
};

export default ErrorDisplay;
